import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  selectVehicleSessionsListStatus,
  vehicleSessionsByDepartmentAsync,
} from "../../home/fleet/fleetSlice";
import { VehicleSessionDisplayed } from "../../home/fleet/fleetApi";
import { SharedInterfaceVehicleSessions } from "../../home/fleet/vehicleSessions/sharedInterface";
import { VehicleSessionSidePanel } from "../../home/fleet/vehicleSessions/sidePanel/SidePanel";
import { selectCurrentDepartment } from "../departments/departmentsSlice";

export const VehicleSessionsTab = () => {
  const params = useParams();
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const firstPath = routerLocation.pathname.split("/")[1];
  const dispatch = useAppDispatch();
  const department = useAppSelector(selectCurrentDepartment);
  const vehicleSessionsListStatus = useAppSelector(
    selectVehicleSessionsListStatus,
  );

  useEffect(() => {
    if (department && vehicleSessionsListStatus === "idle") {
      void dispatch(vehicleSessionsByDepartmentAsync(department.uuid));
    }
  }, [department, dispatch, vehicleSessionsListStatus]);

  const sidePanelAction = useCallback(
    (row: Partial<VehicleSessionDisplayed> & { id?: string }) => {
      navigate(`/${firstPath}/fleet/vehicle_sessions/${row.id}`);
    },
    [navigate, firstPath],
  );

  if (params.tab !== "vehicle_sessions") {
    return;
  }

  return (
    <SharedInterfaceVehicleSessions
      sidePanelAction={sidePanelAction}
      sidePanel={(sidePanelProps) => (
        <VehicleSessionSidePanel
          sessionWithFinalRestitution={sidePanelProps.session}
          previousSessionId={sidePanelProps.previousSessionId}
          nextSessionId={sidePanelProps.nextSessionId}
        />
      )}
    />
  );
};
